import React, { FC, memo, useMemo } from 'react';
import { IAreaChartItem, IBarChartCardProps } from 'models';
import { ChartCard } from '../ChartCard';

const BARS = [{ dataKey: 'amount', name: '', fill: '#65ABFF' }];

const AreaChartCard: FC<IBarChartCardProps<IAreaChartItem>> = memo(
	({ data, getData, isProfit, title, subtitle, isInvestment, minPointSize, helper }) => {
		const total = useMemo(
			() => data.reduce((total, item) => total + Number(item.amount), 0),
			[data],
		);

		const bars = useMemo(
			() =>
				isInvestment
					? BARS.map((item) => {
							return { ...item, fill: '#FB827A' };
					  })
					: BARS,
			[isInvestment],
		);

		return (
			<ChartCard
				title={title}
				isProfit={isProfit}
				getData={getData}
				subtitle={subtitle}
				isBar
				data={data}
				total={total}
				bars={bars}
				minPointSize={minPointSize}
				helper={helper}
			/>
		);
	},
);

export { AreaChartCard };
